export default "__VITE_ASSET__DGUx92JR__"